import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        name: 'registration',
        path: '/registration',
        component: () => import('./account-registration-page.vue'),
        meta: {
            layout: 'blank-layout'
        }
    },
    {
        name: 'production-house-registration',
        path: '/production-house-registration',
        component: () => import('./production-house-profile-details-registration-page.vue'),
        meta: {
            layout: 'blank-layout'
        }
    },
    {
        name: 'freelancer-registration',
        path: '/freelancer-registration',
        component: () => import('./freelancer-profile-details-registration-page.vue'),
        meta: {
            layout: 'blank-layout'
        }
    },
]

export default routes;
